import React from "react";
import "./gradient.css";

const GradientBg = () => {
  return (
    <section className="scl--svg-gradient-care">
      <svg
        className="scl--svg-gradient-care__bg"
        width="1729"
        height="1165"
        viewBox="0 0 1729 1165"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
      >
        <g clipPath="url(#clip0)">
          <g transform="matrix(-1.029 -0.6375 -1.88024 3.03493 1733.5 0.499732)">
            <foreignObject x="-1727.52" y="-1727.52" width="3455.05" height="3455.05">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background:
                    "conic-gradient(from 90deg, #C47257 0deg, #000 225.944deg, rgba(196,114,87,.5) 306.468deg, #C47257 360deg)",
                }}
              />
            </foreignObject>
          </g>
        </g>

        <g clipPath="url(#clip1)">
          <g transform="matrix(0.761 -0.4995 1.47322 2.24449 -5.49996 0.499877)">
            <foreignObject x="-2345.97" y="-2345.97" width="4691.93" height="4691.93">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background:
                    "conic-gradient(from 90deg, #C47157 0deg, #000 229.102deg, rgba(196,114,87,.5) 321.226deg, #C47157 360deg)",
                }}
              />
            </foreignObject>
          </g>
        </g>

        <defs>
          <clipPath id="clip0">
            <rect
              width="5129"
              height="1739"
              transform="matrix(0 -1 -1 0 2603 2565)"
            />
          </clipPath>

          <clipPath id="clip1">
            <rect
              x="-875"
              y="2565"
              width="5129"
              height="1739"
              transform="rotate(-90 -875 2565)"
            />
          </clipPath>
        </defs>
      </svg>
    </section>
  );
};

export default GradientBg;
